import { Component, HostBinding, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { slideInAnimation, slideOutAnimation } from '@app/shared/animations';

/**
 * NavComponent
 */
@Component({
  selector: 'ecp-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  animations: [
    trigger('visibilityChange', [
      transition(':enter', [
        useAnimation(slideInAnimation, {
          params: { timings: '400ms ease-out', from: '20%' },
        }),
      ]),
      transition(':leave', [
        useAnimation(slideOutAnimation, {
          params: { timings: '400ms ease-out', to: '20%' },
        }),
      ]),
    ]),
  ],
  standalone: false,
})
export class NavComponent {
  @HostBinding('class.nav') nav = true;

  @HostBinding('class.to-right')
  /**
   * toRight
   */
  @Input()
  toRight: boolean;
  /**
   * animation
   * @type {boolean}
   */
  @HostBinding('@visibilityChange') animation = true;
}
